import * as React from 'react'

import { ContactCards } from './sections/ContactCards'
import { Hero } from './sections/Hero'
import { Illustrations } from './sections/Illustrations'
import { Media } from './sections/Media'
import { Newsletter } from './sections/Newsletter'
import { Stats } from './sections/Stats'
import type { UluleStats } from '../_shared/ululeStats'

/**
 * Press page ("Espace Presse") main content.
 *
 * Both server-rendered (prerender) and hydrated on the client, so it must stay pure: no
 * `window`/`document`/`localStorage`/`matchMedia` reads and no per-request/browser-only values.
 * The site header/footer are NOT part of this tree — they are mounted separately (see entry-client).
 */
export function App({ initialStats = null }: { initialStats?: UluleStats | null }): React.ReactElement {
  return (
    <main>
      <Hero />
      <Stats initialStats={initialStats} />
      <ContactCards />
      <Newsletter />
      <Illustrations />
      <Media />
    </main>
  )
}
